import React from 'react';
import {View, Text} from '@react-pdf/renderer';
import styles from '../styles';
import {ControlItem, ControlName} from './ControlsComponents';

const FourthSection = props => {
  return (
    <View style={styles.row}>
      <View
        style={[
          styles.width5,
          styles.sectionHeader,
          styles.center,
          {paddingVertical: 12},
        ]}>
        <Text style={[styles.text10, styles.rotated, {width: '250%'}]}>
          ÇDO TRE MUAJ
        </Text>
      </View>
      <View style={[styles.flex1, styles.borderLeft]}>
        <View style={[styles.row, styles.flex1]}>
          <ControlName text="Handrail (parmaku i gomës)" />
          <View style={styles.flex1}>
            <View style={[styles.row, styles.flex1]}>
              <ControlItem
                text="Kontrollo tensionin (shtrëngimin e parmakut)"
                style={[styles.flex1]}
                selected={props.check51}
              />
            </View>
            <View style={[styles.row, styles.flex1]}>
              <ControlItem
                text="Pastroni parmakun"
                style={[styles.flex1]}
                selected={props.check52}
              />
            </View>
            <View style={[styles.row, styles.flex1]}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check53}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default FourthSection;
